import { StateCreator } from 'zustand';
import { allSlices, toolSlice } from './interface';
import { COLORS, LINEWIDTH, TOOLS } from '@/utils/constants';
import { socket } from '@/services/socket';
import socketEvents, { frontendEvents } from '@/utils/socketEvents';

const createToolSlice: StateCreator<allSlices, [], [], toolSlice> = (set) => ({
  tool: TOOLS.PEN,
  color: COLORS.PEN.default,
  highlighterColor: COLORS.HIGHLIGHTER.default,
  lineWidths: {
    PEN: LINEWIDTH.PEN.small,
    HIGHLIGHTER: LINEWIDTH.HIGHLIGHTER.small,
    ERASER: LINEWIDTH.ERASER.large,
    SHAPES: LINEWIDTH.DEFAULT
  },
  fill: false,
  setTool: (tool, sendEvent = true) =>
    set((state) => {
      if (state.room.userId === state.room.presenterId && sendEvent && state.tools.tool !== tool) {
        socket.emit(socketEvents.board.DRAW, {
          roomId: state.room.roomId,
          userId: state.room.userId,
          boardData: { name: frontendEvents.toolconfig.TOOL, tool },
          save: false
        });
      }
      return { tools: { ...state.tools, tool } };
    }),
  setColor: (color) => set((state) => ({ tools: { ...state.tools, color } })),
  setHighlighterColor: (color) =>
    set((state) => ({ tools: { ...state.tools, highlighterColor: color } })),
  setLineWidth: (lineWidth, type) =>
    set((state) => ({
      tools: { ...state.tools, lineWidths: { ...state.tools.lineWidths, [type]: lineWidth } }
    })),
  setFill: (fill) => set((state) => ({ tools: { ...state.tools, fill } }))
});

export default createToolSlice;
